import { action, computed, makeObservable, observable } from 'mobx';
import { UploadTask } from '../../services/upload';
import { Message, StoreNode, StoreNodeProps } from '../../store';
import { Store } from '../../store/store';
import { WindowState } from '../../components/overlays';

export class CancelUploadWindowState
  extends StoreNode {

  readonly nodeType = 'CancelUploadWindow';

  constructor(store: Store, props?: StoreNodeProps) {
    super(store, props);
    makeObservable(this, {
      isLoading: observable,
      task: observable,
      isUploadFinished: computed,
      uploadSource: computed,
      isReplacingVideo: computed,
      cancel: action,
      open: action,
      close: action,
    });
    this.window.listen(
      this.windowListener);
  }

  isLoading = false;
  task: UploadTask | null = null;

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        if (this.isLoading)
          return;
        this.close();
        break;
    }
  }

  readonly window = new WindowState(this.store);

  get isUploadFinished() {
    return this.task?.status !== 'uploading';
  }

  get uploadSource() {
    const sync = this.task?.synchronizer;
    const teamId = sync?.teamId;

    return teamId ? this.store.teamManager.getTeam(teamId)?.name : 'My Uploads';
  }

  get isReplacingVideo() {
    return !!this.task?.synchronizer.replacingJob;
  }

  async submit() {
    if (!this.task) return;
    this.task.cancel();
    this.close();
  }

  cancel() {
    this.close();
  }

  open({ task }: { task: UploadTask }) {
    this.dispatch('Overlays', 'openWindow', { name: 'CancelUploadWindow' });
    this.task = task;
  }

  close() {
    this.dispatch('Overlays', 'closeWindow');
    this.task = null;
  }
}